<div class="bundle-display-card">
  <div class="practice-row">
    <gc-profile-picture class="logo" [fullName]="bundle.practiceName" [imgSrc]="bundle.practiceLogo"></gc-profile-picture>
    <div class="practice-info">
      <span class="practice-name">{{ bundle.practiceName }}</span>
      <span *ngIf="bundle.physicalAddress" class="address">{{ bundle.physicalAddress }}</span>
    </div>
    <div class="actions">
      <gc-communication-actions
        [landlines]="bundle.contactNumbers"
        [googleMapsLink]="bundle.googleMapsLink"
        [emailAddress]="bundle.primaryEmail"
      ></gc-communication-actions>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="bundle-section">
    <div class="bundle-name">{{ bundle.bundleName }}</div>
    <div class="bundle-description" *ngIf="bundle.bundleDescription">{{ bundle.bundleDescription }}</div>
  </div>
  <div class="user-row" *ngIf="bundle.patientFullName">
    <span class="label">{{ 'patient' | translate }}:</span>
    {{ bundle.patientFullName }}
  </div>
</div>
